import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNavigationStore } from '../stores/navigationStore';

export function ReturnToLocationButton() {
  const navigate = useNavigate();
  const { previousLocation, clearPreviousLocation } = useNavigationStore();

  if (!previousLocation) return null;

  const handleReturn = () => {
    if (previousLocation) {
      navigate(previousLocation.pathname, { 
        state: previousLocation.state,
        replace: true 
      });
      clearPreviousLocation();
    }
  };

  return (
    <button
      onClick={handleReturn}
      className="fixed bottom-4 right-4 bg-gold-500 text-gray-900 rounded-full p-3 shadow-lg hover:bg-gold-400 transition-colors z-50 flex items-center gap-2"
      title="Return to previous location"
    >
      <ArrowLeft size={20} />
      <span>Return</span>
    </button>
  );
}
